// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2p3S3AQfGuh1wl {\n  cursor: pointer;\n  margin: 8px 16px 8px 0;\n  height: max-content;\n  width: 304px;\n}\n@media only screen and (max-width: 951px) {\n  ._2p3S3AQfGuh1wl {\n    margin: 8px;\n  }\n}\n.OgMDzWro79ckZ_ {\n  cursor: default;\n  margin: 16px 0 0 0;\n  width: 100%;\n}\n.SMGtamxEfXWc6i {\n  justify-self: start;\n  width: max-content;\n  text-decoration: none;\n}\n._3izG50zM9U1cTx {\n  border-radius: 3px;\n  font-weight: normal;\n  height: 24px;\n  line-height: 16px;\n  margin: 0;\n  padding: 4px 8px;\n  min-width: 64px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"powerUpItem": "_2p3S3AQfGuh1wl",
	"listingPowerUpItem": "OgMDzWro79ckZ_",
	"buttonAnchor": "SMGtamxEfXWc6i",
	"addButton": "_3izG50zM9U1cTx"
};
export default ___CSS_LOADER_EXPORT___;
